"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU_DESKTOP_ITEMS = exports.EMenuItems = void 0;
let EMenuItems = exports.EMenuItems = /*#__PURE__*/function (EMenuItems) {
  EMenuItems[EMenuItems["Buy"] = 0] = "Buy";
  EMenuItems[EMenuItems["Rent"] = 1] = "Rent";
  EMenuItems[EMenuItems["Daily"] = 2] = "Daily";
  EMenuItems[EMenuItems["Calculate"] = 3] = "Calculate";
  EMenuItems[EMenuItems["Mortgage"] = 4] = "Mortgage";
  EMenuItems[EMenuItems["Realtor"] = 5] = "Realtor";
  return EMenuItems;
}({});
const MENU_DESKTOP_ITEMS = exports.MENU_DESKTOP_ITEMS = [{
  href: '/kupit/',
  children: 'Купить',
  id: EMenuItems.Buy
}, {
  href: '/snyat/',
  children: 'Снять',
  id: EMenuItems.Rent
}, {
  href: '/posutochno/',
  children: 'Посуточно',
  id: EMenuItems.Daily
}, {
  href: '/kalkulator-nedvizhimosti/',
  children: 'Оценить',
  id: EMenuItems.Calculate
}, {
  href: '/mortgage/',
  children: 'Ипотека',
  id: EMenuItems.Mortgage
}, {
  href: '/podbor-rieltora/',
  children: 'Подбор риелтора',
  id: EMenuItems.Realtor
}];